module.exports = __webpack_public_path__ + "img/01_exploration.32977503.png";